import { SettingsPage } from '../contexts/settings-modal-context';

/**
 * Converts a SettingsPage enum value to a URL-friendly tab parameter
 */
export const pageToTabParam = (page: SettingsPage): string => {
  return page.toLowerCase().replace(/\s+/g, '-');
};

/**
 * Converts a URL tab parameter back to a SettingsPage enum value
 */
export const tabParamToPage = (
  tabParam: string | null,
  pageMap: Record<string, SettingsPage>,
  defaultPage: SettingsPage,
): SettingsPage => {
  if (!tabParam) return defaultPage;

  const normalized = tabParam.toLowerCase().replace(/-/g, ' ');
  return pageMap[normalized] || defaultPage;
};
